import React from "react";
import PropTypes from "prop-types";

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";

export const DMapDialog = ({ DMapDialogOpen, handleClose, newMapping, props, code, name, setCode, setName }) => {
    const handleAddCode = (newEntry, foundObject) => {
        let newState = props.value;
        const selectedType = newMapping.Selected["type"];

        if (newState[selectedType]) {
            const existingIndex = newState[selectedType].findIndex(
                (obj) => obj["CUST CODE"] === (newEntry ? newEntry["CUST CODE"] : foundObject["CUST CODE"])
            );

            if (existingIndex !== -1) newState[selectedType][existingIndex] = newEntry ? newEntry : foundObject;
            else newState[selectedType].push(newEntry ? newEntry : foundObject);
        }

        if (!newEntry) {
            newState["DMAPSTORE"] = newState["DMAPSTORE"].filter(
                (obj) => obj["CUST CODE"] !== foundObject["CUST CODE"]
            );
        }

        newState = SortAccounts(newState);
        props.saveValue(props.editCell.POA, props.editCell.key_path, newState);
        handleClose();
    };

    const handleAddLyvesCode = () => {
        const newEntry = {
            "CUST CODE": code,
            "CUSTOMER NAME 1": name,
        };

        setName("");
        setCode("");

        handleAddCode(newEntry, null);
    };

    const handleAddMappedCode = () => {
        handleAddCode(null, newMapping.Found);
    };

    return (
        <Dialog
            open={DMapDialogOpen}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{"D365 Mapping Found!"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    A Mapping has been found! Would you like to Add the Mapped D365 Codes or continue adding with the
                    LYVES code. Note Adding the D365 Code will use the NEW DCodes instead of the Lyves Code.
                </DialogContentText>
                <DialogContentText style={{ display: "flex", flexDirection: "column" }}>
                    <span>
                        DMapLyves Code: <strong>{newMapping?.Found?.["CUST CODE"]}</strong>
                    </span>
                    <span>
                        DMapD365 Code: <strong>{newMapping?.Found?.["D365_CODE"]}</strong>
                    </span>
                    <span>
                        DMap Name: <strong>{newMapping?.Found?.["CUSTOMER NAME 1"]}</strong>
                    </span>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleAddLyvesCode}>Just Add Lyves Code</Button>
                <Button onClick={handleAddMappedCode} autoFocus>
                    Add Mapped Code
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export const findDMapping = ({ code, name, type, props, setNewMapping, setName, setCode }) => {
    const dmapStore = props.value["DMAPSTORE"];
    let dMap = false;

    if (dmapStore) {
        const foundObject = dmapStore.find((mapping) => mapping["CUST CODE"] === code);

        if (foundObject) {
            // Mapping Found
            setNewMapping({ Found: foundObject, Selected: { name, type } });
            dMap = true;
        }
    }

    if (!dMap) {
        handleStandard({ props, code, name, type, setName, setCode });
    }
};

// Handle Saving Standard Accounts
export const handleStandard = ({ props, code, name, type, setName, setCode }) => {
    let newState = props.value;

    const newEntry = {
        "CUST CODE": code,
        "CUSTOMER NAME 1": name,
    };

    setName("");
    setCode("");

    // Handle case where this type doesn't already exist
    if (!newState[type]) newState[type] = [];

    const existingIndex = newState[type].findIndex(
        (obj) => obj["CUST CODE"] === (newEntry["CUST CODE"])
    );

    if (existingIndex !== -1) newState[type][existingIndex] = newEntry;
    else newState[type].push(newEntry);

    newState = SortAccounts(newState);
    props.saveValue(props.editCell.POA, props.editCell.key_path, newState);

    // For unit testing purposes
    newState = props.value;
    return newState;
};

const SortAccounts = (pricing_accounts) => {
    // loop over each pricing account
    for (const account in pricing_accounts) {
        // sort by customer name or cust code if name is not available
        pricing_accounts[account].sort((a, b) => {
            const nameA = (a["CUSTOMER NAME 1"] || a["CUST CODE"]).toLowerCase();
            const nameB = (b["CUSTOMER NAME 1"] || b["CUST CODE"]).toLowerCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
    }
    return pricing_accounts;
};

handleStandard.propTypes = {
    props: PropTypes.object.isRequired,
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.oneOf(["CC", "STANDARD", "PAT"]).isRequired,
    setName: PropTypes.func.isRequired,
    setCode: PropTypes.func.isRequired,
};

DMapDialog.propTypes = {
    DMapDialogOpen: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    newMapping: PropTypes.object.isRequired,
    props: PropTypes.object.isRequired,
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    setCode: PropTypes.func.isRequired,
    setName: PropTypes.func.isRequired,
};
